import AppPromoBanner from "@/components/app-promo-banner";
import React from "react";
import { useCmsSection } from "@/hooks/useCmsContent";
import { useCmsList } from "@/hooks/useCmsList";
import { useCms } from "@/context/CmsContext";
import Editable from "@/components/cms/Editable";
import styles from './index.module.css';

interface FormLink {
    id?: number;
    title: string;
    url: string;
}

const FALLBACK_FORMS: FormLink[] = [
    { title: 'Transaction Dispute Form', url: '/assets/pdf/transactionDisputeForm.pdf' },
    { title: 'Name Change Form', url: '/assets/pdf/Kwik-Fill-Charge-Card-Name-Change-Form.pdf' },
    { title: 'New Account Notice', url: '/assets/pdf/newaccountnotice.pdf' },
    { title: 'Statement Disclaimer', url: '/assets/pdf/statementdisclaimer.pdf' },
    { title: 'Contact Card Services', url: '/help' },
];

export default function HelpForms() {
    const { fields } = useCmsSection('help-forms', 'body', {
        title: 'Card Services Forms',
        subtitle: 'Thank you for signing in. Using the links on this page, you can enter our giveaways see your entries, and view the winners. You can also update your user information and register to become a Kwik Rewards Club VIP.',
    });
    const { items: cmsForms, add, remove } = useCmsList<FormLink>('help-forms');
    const { isAdmin, isEditMode } = useCms();

    const forms = cmsForms.length > 0 ? cmsForms : FALLBACK_FORMS;

    const [showAdd, setShowAdd] = React.useState(false);
    const [newTitle, setNewTitle] = React.useState('');
    const [newUrl, setNewUrl] = React.useState('');

    return (
        <div className={styles.container}>
            <div>
                <Editable page="help-forms" section="body" field="title" value={fields.title}>
                    <div className={styles.title}>{fields.title}</div>
                </Editable>
                <Editable page="help-forms" section="body" field="subtitle" value={fields.subtitle}>
                    <div className={styles.subtitle}>{fields.subtitle}</div>
                </Editable>
            </div>

            <div className={styles.section_container}>
                {forms.map((form, i) => (
                    <p key={form.id || i} style={{ position: 'relative' }}>
                        <a href={form.url}>{form.title}</a>
                        {isAdmin && isEditMode && form.id && (
                            <button
                                onClick={() => remove(form.id!)}
                                style={{
                                    background: '#ef4444', color: 'white', border: 'none',
                                    width: 20, height: 20, borderRadius: '50%', fontSize: 12,
                                    cursor: 'pointer', marginLeft: 8, verticalAlign: 'middle',
                                }}
                            >
                                &times;
                            </button>
                        )}
                    </p>
                ))}

                {isAdmin && isEditMode && (
                    <>
                        {!showAdd ? (
                            <button
                                onClick={() => setShowAdd(true)}
                                style={{
                                    background: '#3b82f6', color: 'white', border: 'none',
                                    padding: '6px 14px', borderRadius: 8, fontSize: 13,
                                    fontWeight: 600, cursor: 'pointer', fontFamily: 'system-ui',
                                }}
                            >
                                + Add Form Link
                            </button>
                        ) : (
                            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8 }}>
                                <input
                                    placeholder="Title" value={newTitle}
                                    onChange={e => setNewTitle(e.target.value)}
                                    style={{ padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 14 }}
                                />
                                <input
                                    placeholder="URL" value={newUrl}
                                    onChange={e => setNewUrl(e.target.value)}
                                    style={{ padding: '6px 10px', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 14, flex: 1 }}
                                />
                                <button
                                    onClick={async () => {
                                        await add({ title: newTitle, url: newUrl });
                                        setNewTitle(''); setNewUrl(''); setShowAdd(false);
                                    }}
                                    disabled={!newTitle || !newUrl}
                                    style={{ background: '#22c55e', color: 'white', border: 'none', padding: '6px 14px', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}
                                >
                                    Add
                                </button>
                                <button onClick={() => setShowAdd(false)}
                                    style={{ background: '#6b7280', color: 'white', border: 'none', padding: '6px 14px', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}>
                                    Cancel
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>

            <div style={{ marginTop: 120, marginBottom: 60 }}>
                <AppPromoBanner />
            </div>
        </div>
    );
}
